import { computed } from "@angular/core";
import { signalStoreFeature, type, withComputed } from "@ngrx/signals";
import { IProviderState } from "./provider.state";

export const withProviderComputed = signalStoreFeature(
    { state: type<IProviderState>() },
    withComputed(({ provider, loading, error }) => ({
        providerGuid: computed(() => provider()?.providerGuid ?? ''),
        isVerified: computed(() => !!provider()?.isVerified),
        isLoading: computed(() => loading()),
        hasError: computed(() => !!error())
    }))
);
